import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { ResearchAreaActionType } from '../actionTypes/researchArea';
import { PostDispatch, ResearchArea } from '../types';

export const createResearchArea =
    (researchArea: ResearchArea) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(`/researchArea`, researchArea);
        dispatch({
            type: ResearchAreaActionType.CREATE_RESEARCH_AREA,
            payload: response.data,
        });
    };

export const updateResearchArea =
    (researchArea: ResearchArea) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(
            `/researchArea/${researchArea._id}`,
            researchArea
        );
        dispatch({
            type: ResearchAreaActionType.UPDATE_RESEARCH_AREA,
            payload: response.data,
        });
    };

export const updateResearchAreaInUse =
    (researchArea: ResearchArea) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(
            `/researchArea/updateResearchAreaInUse`,
            {
                researchArea,
            }
        );

        dispatch({
            type: ResearchAreaActionType.UPDATE_RESEARCH_AREA,
            payload: response.data,
        });
    };

export const deleteResearchArea =
    (researchArea: ResearchArea) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.delete(
            `/researchArea/${researchArea._id}`
        );
        dispatch({
            type: ResearchAreaActionType.DELETE_RESEARCH_AREA,
            payload: response.data,
        });
    };

export const getAllResearchAreasByUserIntakes =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/researchArea/userIntakes`);
        dispatch({
            type: ResearchAreaActionType.GET_RESEARCH_AREAS_BY_USER_INTAKES,
            payload: response.data,
        });
    };

export const getAllResearchAreasForSupervisor =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/researchArea/supervisor/id`);
        dispatch({
            type: ResearchAreaActionType.GET_ALL_RESEARCH_AREAS,
            payload: response.data,
        });
    };
